import React from "react";

import { ApiGmwGmwsListRequest, GMW } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { TableOverview } from "@/components/table-overview";
import { renderDefault, renderEnum } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { useGmwListQuery } from "@/queries/query-gmw";

import { useGmwContext } from "../../contexts/gmw-context";
import { gmwInformation } from "../../types";

import { GmwEventTable } from "./components/gmw-event-table";

const columnDefinitions: ColumnDefinition<GMW>[] = gmwInformation.map(
  ({ enum: enumValue, label, key }, index) => ({
    title: label,
    renderFunction: (row) => {
      const value = row[key];
      if (enumValue) return renderEnum(value, enumValue);
      return renderDefault(value, index === 0 ? `/gmw/constructie/${row.uuid}/` : undefined);
    },
    width: "1fr",
  })
);

const GmwTable: React.FC = () => {
  const { gmwFilters, setPage } = useGmwContext();
  const { page, search } = gmwFilters;
  const queryParams: ApiGmwGmwsListRequest = {
    page,
    // FUTURE
    // linkedGmns: gmnIds && gmnIds.length > 0 ? gmnIds.toString() : undefined,
    ...(search ? { [search.searchField]: search.searchString } : {}),
  };
  const { data: gmwList, isLoading } = useGmwListQuery(queryParams);
  const paginationProps = useQueryPagination({
    queryResponse: gmwList,
    page,
    setPage,
  });

  return (
    <TableOverview
      isLoading={isLoading}
      rowAccordion={({ nrOfIntermediateEvents, broId }: GMW) => {
        if (nrOfIntermediateEvents) return <GmwEventTable gmwBroId={broId} />;
        return null;
      }}
      tableData={gmwList?.results || []}
      columnDefinitions={columnDefinitions}
      paginationProps={paginationProps}
    />
  );
};

export { GmwTable };
